import { Section, SectionHeader } from '@/ui/components'
import { Slide, Slider } from '@/ui/components/Slider'
import { memo } from 'react'
import SectionSliderCard from './SectionSliderCard'
import { SectionSliderType } from './type'

const SectionSlider = ({
  section,
  sectionHeaderData,
  items
}: SectionSliderType) => (
  <Section data={section} className="s-section-slider">
    <SectionHeader {...sectionHeaderData} />
    {items && items.length > 0 && (
      <Slider
        className="pt-md"
        slidesPerView={items.length > 1 ? 1.2 : 1}
        slidesPerViewMd={items.length > 1 ? 1.1 : 1}
        spaceBetween="var(--spacing-gutter)"
        showCounter={true}
        sliderOptions={{
          loop: true
        }}
      >
        {items &&
          items?.map((item, index) => (
            <Slide key={index?.toString()}>
              <SectionSliderCard {...item} />
            </Slide>
          ))}
      </Slider>
    )}
  </Section>
)

SectionSlider.displayName = 'SectionSlider'

export default memo(SectionSlider)
